import React, { Component } from "react";
import {
  Button,
  Container,
  Grid,
  Paper,
  Snackbar,
  Typography,
} from "@material-ui/core";

import { Card, CardBody, Row, Col } from "reactstrap";

import axios from "axios";
import Constants from "../Variables/Constants";

export default class Order_Details extends Component {
  state = {
    order_details: {},
    delivery_link: "",
    notification: false,
    message: "",
  };

  componentDidMount() {
    this.getSingleOrder();
  }

  /* GET ORDER */

  getSingleOrder = () => {
    const id = window.location.pathname.split("/")[3];

    axios
      .get(Constants.getUrls.getSingleOrder + "/" + id)

      .then((resp) => {
        const order = resp.data.data;

        this.setState({
          order_details: order,
          delivery_link: order.delivery_link || "",
        });
      });
  };

  /* UPDATE DELIVERY LINK */

  updateDeliveryLink = () => {
    const id = window.location.pathname.split("/")[3];

    axios
      .put(Constants.putUrls.updateDeliveryLink + "/" + id, {
        delivery_link: this.state.delivery_link,
      })

      .then((resp) => {
        const updatedOrder = resp.data.data;

        this.setState({
          order_details: updatedOrder,
          delivery_link: updatedOrder.delivery_link || "",
          notification: true,
          message: "Delivery link updated successfully",
        });

        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);

        this.getSingleOrder();
      })

      .catch((err) => {
        this.setState({
          notification: true,
          message: "Failed to update delivery link",
        });

        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);
      });
  };

  /* CANCEL ORDER */

  cancelOrder = () => {
    const id = window.location.pathname.split("/")[3];

    axios
      .put(Constants.putUrls.cancelOrder + "/" + id)

      .then((resp) => {
        this.setState({
          order_details: resp.data.data,
          notification: true,
          message: "Order cancelled successfully",
        });

        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);

        this.getSingleOrder();
      })

      .catch((err) => {
        this.setState({
          notification: true,
          message: err.response?.data?.message || "Cancel failed",
        });

        setTimeout(() => {
          this.setState({ notification: false });
          window.location.href = "/orders";
        }, 2000);
      });
  };

  render() {
    const order = this.state.order_details;
    const deliveryCharge = Number(order.delivery_charge || 0);
    const totalAmount = Number(order.order_amount || 0);
    const subtotalAmount = Math.max(totalAmount - deliveryCharge, 0);

    return (
      <Container maxWidth="xl">
        {/* Notification */}

        {this.state.notification && (
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={true}
            message={this.state.message}
          />
        )}

        <Typography variant="h4" style={{ marginBottom: "20px" }}>
          Order Details
        </Typography>

        <Paper elevation={3}>
          <Card style={{ padding: "20px" }}>
            {/* CUSTOMER DETAILS */}

            <Row>
              <Col md={6}>
                <Typography style={{ fontWeight: "bold" }}>
                  Customer Details
                </Typography>

                <Typography>Name: {order.user_name}</Typography>

                <Typography>Mobile: {order.mobile_no}</Typography>

                <Typography>Address:</Typography>

                <div
                  style={{
                    background: "#111",
                    padding: "10px",
                    borderRadius: "6px",
                    marginTop: "5px",
                  }}
                >
                  {order.address?.line1}
                  <br />
                  {order.address?.line2}
                  <br />
                  {order.address?.city}, {order.address?.state}
                  <br />
                  {order.address?.country} - {order.address?.postalCode}
                </div>
              </Col>

              {/* ORDER DETAILS */}

              <Col md={6}>
                <Typography style={{ fontWeight: "bold" }}>
                  Order Info
                </Typography>

                <Typography>Order ID: {order.order_date_id || order._id}</Typography>

                <Typography>Order Date: {order.order_date}</Typography>

                <Typography>
                  Payment Mode: {(order.payment_mode || "online").toUpperCase()}
                </Typography>

                <Typography>
                  Payment Status: {(order.payment_status || "pending").toUpperCase()}
                </Typography>

                {/* <Typography>Return Date: {order.return_date}</Typography> */}

                <Typography>
                  Status:
                  <span
                    style={{
                      color: "#1976d2",
                      fontWeight: "bold",
                      marginLeft: "5px",
                    }}
                  >
                    {order.order_status}
                  </span>
                </Typography>

                <Typography>Subtotal: ₹{subtotalAmount}</Typography>

                <Typography>
                  Delivery Charges: ₹{deliveryCharge}
                </Typography>

                <Typography style={{ fontWeight: "bold" }}>
                  Total Amount: ₹{totalAmount}
                </Typography>
              </Col>
            </Row>

            <hr />

            {/* DELIVERY LINK */}

            <Row style={{ marginTop: "20px" }}>
              <Col md={12}>
                <Typography style={{ fontWeight: "bold" }}>
                  Delivery Link
                </Typography>

                <input
                  type="text"
                  value={this.state.delivery_link}
                  onChange={(e) =>
                    this.setState({ delivery_link: e.target.value })
                  }
                  placeholder="Enter delivery link"
                  style={{
                    width: "60%",
                    padding: "10px",
                    marginTop: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />

                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: "15px" }}
                  onClick={this.updateDeliveryLink}
                >
                  Update
                </Button>
              </Col>
            </Row>

            <hr />

            {/* PRODUCT DETAILS */}

            <Typography
              style={{
                fontWeight: "bold",
                marginBottom: "15px",
              }}
            >
              Ordered Products
            </Typography>

            {order.cart_id?.map((item, index) => {
              const product = item.product_id;
              const variant = item.variant_id;

              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    padding: "15px",
                    marginBottom: "15px",
                    display: "flex",
                    gap: "20px",
                  }}
                >
                  {/* IMAGE */}

                  <img
                    src={Constants.imgDomain + variant?.images?.[0]}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "6px",
                    }}
                  />

                  {/* DETAILS */}

                  <div>
                    <Typography>
                      Order Date: {order.order_date
                        ? new Date(order.order_date).toLocaleString()
                        : ""}
                    </Typography>

                    <Typography>
                      Category: {product?.category?.title || product?.category?.name || product?.category}
                    </Typography>

                    <Typography>
                      Variant:
                      {variant?.size} / {variant?.colour}
                    </Typography>

                    <Typography>
                      Price: ₹{variant?.offer_price || variant?.price}
                    </Typography>

                    <Typography>Quantity: {item.quantity}</Typography>

                    {item.custom_text ? (
                      <Typography>Custom Text: {item.custom_text}</Typography>
                    ) : null}

                    {item.custom_photo ? (
                      <div style={{ marginTop: "10px" }}>
                        <Typography>Custom Photo:</Typography>
                        <img
                          src={Constants.imgDomain + item.custom_photo}
                          alt="Custom Upload"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            marginTop: "8px",
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}

            <hr />

            {/* ACTION BUTTON */}

            <Button
              variant="contained"
              color="secondary"
              onClick={this.cancelOrder}
            >
              Cancel Order
            </Button>
          </Card>
        </Paper>
      </Container>
    );
  }
}

// import React, { Component } from "react";
// import {
//   Backdrop,
//   Button,
//   Container,
//   Select,
//   InputLabel,
//   Fade,
//   FormControl,
//   Grid,
//   // Modal,
//   Paper,
//   Snackbar,
//   Switch,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableFooter,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TextField,
//   Typography,
//   FormControlLabel,
// } from "@material-ui/core";
// import "../../App.css";
// import {
//   Card,
//   CardHeader,
//   CardBody,
//   CardTitle,
//   // Table,
//   Row,
//   Col,
//   UncontrolledAlert,
//   Pagination,
//   PaginationItem,
//   PaginationLink,
//   FormGroup,
// } from "reactstrap";

// import Modal from "react-awesome-modal";
// import renderHTML from "react-render-html";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Constants from "../Variables/Constants";
// import init from "../../helpers/WindowToken";
// import { lastPageRecordCount } from "./Components/PaginationTool";
// import "../../App.css";

// export default class Order_Details extends Component {
//   state = {
//     order_details: {},
//   };

//   componentDidMount() {
//     console.log(window.location.pathname.split("/")[3]);
//     this.getSIngleOrder();
//   }

//   getSIngleOrder = () => {
//     axios
//       .get(
//         Constants.getUrls.getSingleOrder +
//           "/" +
//           window.location.pathname.split("/")[3]
//       )
//       .then((resp) => {
//         console.log(resp);
//         this.setState({
//           order_details: resp.data.data,
//         });
//       });
//   };

//   cancelOrder = () => {
//     axios
//       .put(
//         Constants.putUrls.cancelOrder +
//           "/" +
//           window.location.pathname.split("/")[3]
//       )
//       .then((resp) => {
//         this.setState({ notification: true, message: "Order Cancelled !!" });
//         setTimeout(() => {
//           this.setState({ notification: false });
//         }, 2000);
//       })
//       .catch((err) => {
//         this.setState({
//           notification: true,
//           message: err.response.data.message,
//         });
//         setTimeout(() => {
//           this.setState({ notification: false });
//         }, 2000);
//       });
//   };

//   render() {
//     return (
//       <Container maxWidth="xl">
//         <Grid container spcaing={2}>
//           <Grid item sm={6}>
//             <Typography variant="h4">Orders</Typography>
//           </Grid>
//           {this.state.notification ? (
//             <Snackbar
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               open={true}
//               color={"s"}
//               autoHideDuration={6000}
//               message={this.state.message}
//             ></Snackbar>
//           ) : null}
//         </Grid>
//         <Grid sm={12} style={{ padding: "15px" }}>
//           <Paper elevation={1}>
//             <Card style={{ padding: "15px" }}>
//               <Grid container>
//                 <Grid sm="6">
//                   <Typography>
//                     Name: {this.state.order_details.user_name}
//                   </Typography>
//                   <Typography>
//                     Contact: {this.state.order_details.mobile_no}{" "}
//                   </Typography>
//                   <Typography>
//                     {" "}
//                     Address: {this.state.order_details.address}{" "}
//                   </Typography>
//                 </Grid>
//                 <Grid sm="6">
//                   <Typography>
//                     Order Date: {this.state.order_details.order_date}
//                   </Typography>
//                   <Typography>
//                     Return Date: {this.state.order_details.return_date}{" "}
//                   </Typography>
//                   <Typography>
//                     {" "}
//                     Order Status: {this.state.order_details.order_status}{" "}
//                   </Typography>
//                 </Grid>
//               </Grid>
//               {this.state.order_details.qr_code !== "" &&
//                 this.state.order_details.qr_code !== undefined &&
//                 this.state.order_details.qr_code !== null && (
//                   <Grid sm={12}>
//                     <img
//                       style={{ height: "100px", width: "100px" }}
//                       src={
//                         "https://core.mfd.co.in" +
//                         this.state.order_details.qr_code
//                       }
//                       alt=""
//                     />
//                   </Grid>
//                 )}
//               <Grid container sm={12}>
//                 {this.state.order_details.cart_id?.map((item) => (
//                   <>
//                     <Grid sm={6}>
//                       <img
//                         src={
//                           "https://core.mfd.co.in" + item.variant_id.images[0]
//                         }
//                         alt=""
//                         style={{ height: "200px", width: "200px" }}
//                       />
//                     </Grid>
//                     <Grid sm={12}>
//                       <Typography>
//                         Product Name: {item.product_id.name}
//                       </Typography>
//                       <Typography>Ordered Quantity: {item.quantity}</Typography>
//                       <Typography>
//                         Variant (size/Colour): {item.variant_id.size} /{" "}
//                         {item.variant_id.colour}
//                       </Typography>
//                     </Grid>
//                   </>
//                 ))}
//               </Grid>
//               <Button
//                 variant="outlined"
//                 size="small"
//                 color="secondary"
//                 onClick={this.cancelOrder}
//               >
//                 Cancel Order
//               </Button>
//             </Card>
//           </Paper>
//         </Grid>
//       </Container>
//     );
//   }
// }
